module.exports = "pegasus/assets/themelp1/charity/104.png";